<template>
  <component v-bind:is="layout" />
</template>

<script>

export default {

  data() {
    return {
      defaultLayout: 'default',
    };
  },

  mounted () {

  },

  computed: {
    layout () {
      if(!this.$route.name){ return false }
      return (this.$route.meta.layout || this.defaultLayout) + '-layout'
    },
  },

  methods: {

  },

  watch: {

  },

}

</script>


